import { render, staticRenderFns } from "./SupplierCreate.vue?vue&type=template&id=27f1ee7a&scoped=true"
import script from "./SupplierCreate.vue?vue&type=script&lang=ts"
export * from "./SupplierCreate.vue?vue&type=script&lang=ts"
import style0 from "./SupplierCreate.vue?vue&type=style&index=0&id=27f1ee7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f1ee7a",
  null
  
)

export default component.exports